/*
 *
 * GoogleVerify reducer
 *
 */
import produce from 'immer';
import { VERIFY_GOOGLE } from './constants';

export const initialState = {
  isVerify: true,
  error: false,
};

/* eslint-disable default-case, no-param-reassign */
const googleVerifyReducer = (state = initialState, action) => {
  return produce(state, draft => {
    switch (action.type) {
      case VERIFY_GOOGLE.START:
        draft.isVerify = true;
        draft.error = false;
        break;

      case VERIFY_GOOGLE.SUCCESS:
        draft.isVerify = false;
        draft.error = false;
        break;

      case VERIFY_GOOGLE.ERROR:
        draft.isVerify = false;
        draft.error = true;
        break;
    }
  });
};

export default googleVerifyReducer;
